<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div>
  <mat-dialog-content>
    <p-table [value]="projects"
             [rows]="100"
             [paginator]="true"
             [pageLinks]="3"
             [rowsPerPageOptions]="[10, 20, 50, 100]"
             [style]="{'margin-top':'10px'}"
             selectionMode="single"
             [resizableColumns]="true"
             [reorderableColumns]="true"
             (onRowExpand)="getControlItems($event)"
             dataKey="projectId"
             #dashboardTable>

      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
        <tr class="ui-widget-header">
          <td colspan="3">
            <a href="#" [pRowToggler]="item">
              <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              <span>{{item.name}}</span>
            </a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-rowData let-columns="columns">
        <p-table [value]="rowData.projectControlItems"
                 #projectsTable
                 [rows]="100"
                 selectionMode="multiple"
                 dataKey="category"
                 exportFilename="projects"
        >

          <ng-template pTemplate="header">
            <tr [ngStyle]="{'white-space': 'nowrap', 'font-weight': 'bold'}">
              <th *ngFor="let col of cols" [pSortableColumn]="col.field" [ngStyle]="{'width': col['width'] || 'auto'}">
                {{col.header}}
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
            <tr class="ui-widget-header"
                *ngIf="rowGroupMetadata[rowData.projectId][item.controlItem.category].index === rowIndex">
              <td colspan="3">
                <a href="#" [pRowToggler]="item">
                  <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                  <span>{{item.controlItem.complianceArea.name}} - {{item.controlItem.category}}</span>
                </a>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="expandedrow" let-rowIndex="rowIndex" let-item>
            <tr
              (click)="selectProjectControlItem(item)">
              <td>{{item.controlItem.category}}</td>
              <td>{{item.controlItem.complianceAreaControlId}}</td>
              <td>{{item.controlItem.description}}</td>
            </tr>
          </ng-template>
        </p-table>

      </ng-template>
    </p-table>
  </mat-dialog-content>
</div>
